import { s3HttpClient } from '@bcba/client-auth';
import { FILE_MIME_TYPES } from '@bcba/types';
import { getPublicS3SignedUrl } from '../services/documents/getPublicS3SignedUrl';
import { CreateBase64DocumentDto } from '../services/dtos/createBase64DocumentDto';
import { convertReactDocumentToFile } from './convertReactDocumentToFile';

export const convertReactDocumentToBase64 = async (
  reactDocument: Blob,
  documentName: string,
): Promise<CreateBase64DocumentDto> => {
  const file = convertReactDocumentToFile(reactDocument, documentName);
  const binaryData = await reactDocument.arrayBuffer();

  const data = await getPublicS3SignedUrl(file.name).then(async (data) => {
    const { url } = data;
    await s3HttpClient.put(url, binaryData);
    return data;
  });

  const { s3Key } = data;

  return {
    s3TempKey: s3Key,
    name: file.name,
    mimeType: FILE_MIME_TYPES.PDF,
  };
};
export default convertReactDocumentToBase64;
